import { useTranslations } from '@ifixit/i18n/hooks';
import { SSOButton } from './SSOButton';
import { GoogleSSOButton } from './GoogleSSOButton';
import { FacebookSSOButton } from './FacebookSSOButton';
import { AppleSSOButton } from './AppleSSOButton';
import { FormError } from './FormError';
import { getLastLoginMethod } from './LogIn/lastLoginMethod';

export function SSOLoginButtons({
   loginHandler,
   error,
   setError,
   register,
}: {
   loginHandler: (response: any) => void;
   error: string | null;
   setError: (error: string) => void;
   register?: boolean;
}) {
   const t = useTranslations('Login');
   if (
      !(
         App.ssoLoginUrl ||
         App.googleLoginEnabled ||
         App.facebookLoginEnabled ||
         App.appleLoginEnabled
      )
   ) {
      return null;
   }

   const loginHandlerFor = (method: string) => (response: any) => {
      if (response.loggedIn) {
         response.from = method;
      }
      return loginHandler(response);
   };

   const lastMethod = getLastLoginMethod();

   return (
      <>
         <div className="flex flex-col gap-3 w-full">
            {App.ssoLoginUrl && (
               <SSOButton
                  href={App.ssoLoginUrl}
                  text={register ? t('signUpWithSSO') : t('signInWithSSO')}
                  recentlyUsed={lastMethod === 'sso'}
               />
            )}
            {App.googleLoginEnabled && (
               <GoogleSSOButton
                  setError={setError}
                  loginHandler={loginHandlerFor('google')}
                  text={register ? 'signup_with' : 'signin_with'}
                  recentlyUsed={lastMethod === 'google'}
               />
            )}
            <AppleSSOButton
               setError={setError}
               loginHandler={loginHandlerFor('apple')}
               text={register ? t('signUpWithApple') : t('signInWithApple')}
               recentlyUsed={lastMethod === 'apple'}
            />
            <FacebookSSOButton
               setError={setError}
               loginHandler={loginHandlerFor('facebook')}
               text={register ? t('signUpWithFacebook') : t('signInWithFacebook')}
               recentlyUsed={lastMethod === 'facebook'}
            />
            <FormError>{error}</FormError>
         </div>
         <div className="flex items-center justify-center h-5 relative w-full before:content-[''] before:absolute before:top-1/2 before:-translate-y-1/2 before:w-full before:h-px before:bg-border before:border-b before:border-border before:z-0">
            <span className="bg-card inline-flex mx-auto text-sm px-6 relative uppercase">
               {t('or')}
            </span>
         </div>
      </>
   );
}
